<h1 mat-dialog-title>Delete filter</h1>
<div mat-dialog-content>

    Would you like to delete selected filter?    
    
</div>
<div mat-dialog-actions>
    <button mat-button (click)="deleteFilter()">Delete filter</button>
    <button mat-button (click)="onNoClick()">Cancel</button>
</div>